import CommonSidebar from '../../common/sidebar/CommonSidebar';

export default CommonSidebar;